import React from "react";
import { Link } from "react-router-dom";

const Logo = () => {
    return (
        <div className="header-logo-wrapper">
            <Link to="/" className="logo">
                <span>Y</span>
                <span>O</span>
                <span>Z</span>
                <span>U</span>
            </Link>
        </div>
    );
};

export default Logo;
